import React from 'react';
import MenuPainel from '../components/MenuPainel';
import { FilaTelepsicologia } from '../components/FilaTelepsicologia';
import { ChangePassword } from '../components/ChangePassword';
import PaperForm from '../components/PaperForm';
import Alert from '../components/Alert';
import GlobalStyle from '../styles/globalStyle';
import { CssBaseline } from '@material-ui/core';
class AdmFilaTelepsicologia extends React.Component {
  render() {
    const { message, type, open } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <GlobalStyle />
        <ChangePassword />
        <MenuPainel>
          <Alert
            open={open}
            type={type}
            message={message}
            onClose={() => this.handleClose(type, message)}
          />
          <PaperForm
            margin={'20px 0'}
            widthGrid={'90%'}
            width={'100%'}
            elevation={24}
            componente={<FilaTelepsicologia />}
          ></PaperForm>
        </MenuPainel>
      </React.Fragment>
    );
  }
}

const connectedAssinar = AdmFilaTelepsicologia;
export { connectedAssinar as AdmFilaTelepsicologia };
